import React from 'react';
import Breadcrumbs from '../components/Breadcrumbs';
import SeoMeta from '../components/SeoMeta';
import { SOURCES } from '../data/sources';

export default function About() {
  return (
    <article className="space-y-8">
      <SeoMeta
        title="Om Kanmanfryse.dk"
        metaTitle="Om Kanmanfryse.dk — Baggrund og kilder"
        metaDescription="Kanmanfryse.dk er en uafhængig dansk opslagsguide om frysning af mad, udgivet af en privatperson uden kommercielle interesser."
        slug="om"
      />

      <Breadcrumbs title="Om siden" slug="om" />

      <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-[#141B22]">
        Om Kanmanfryse.dk
      </h1>

      <div className="space-y-6 text-[17px] text-[#141B22] leading-relaxed">
        <p>
          Kanmanfryse.dk er et uafhængigt opslagsværk skabt til at besvare det enkle, men vigtige spørgsmål, som mange står med i køkkenet med en rest i hånden: Kan denne madvare fryses, hvor længe kan den holde sig, og hvordan gøres det rigtigt?
        </p>

        <h2 className="text-xl font-bold text-[#141B22] pt-4 border-t border-[#DCE3EC]">
          Uafhængig afsender
        </h2>
        <p>
          Sitet udgives og vedligeholdes af en privatperson med stor interesse for madlavning, råvareudnyttelse og reduktion af madspild i husholdningen. Der påstås ingen formel faglig titel, og sitet repræsenterer ingen organisation, fødevareproducent eller forhandler.
        </p>
        <p>
          Her sælges ingen varer, der vises ingen reklamer, og der modtages ingen betaling for omtale af fødevarer eller opbevaringsmetoder. Formålet er udelukkende at samle pålidelig, praktisk viden på ét overskueligt sted.
        </p>

        <h2 className="text-xl font-bold text-[#141B22] pt-4 border-t border-[#DCE3EC]">
          Faktabaseret indhold og kilder
        </h2>
        <p>
          Oplysningerne på sitet er ikke baseret på tilfældige husråd, men bygger systematisk på officielle anbefalinger og dokumenterede undersøgelser fra troværdige institutioner. De primære kilder er:
        </p>
        <ul className="list-disc pl-5 space-y-2 text-[#141B22]">
          <li>
            <strong>Fødevarestyrelsen</strong> (anbefalinger om temperaturer, hygiejne, optøning og mikrobiologisk fødevaresikkerhed).
          </li>
          <li>
            <strong>Forbrugerrådet Tænk</strong> (vejledninger om madopbevaring, frysning og holdbarhedstabeller).
          </li>
        </ul>
        <p>
          Hver enkelt artikel på sitet afsluttes med en kildehenvisning til de konkrete sider, der ligger til grund for artiklens tal og anvisninger.
        </p>

        <h2 className="text-xl font-bold text-[#141B22] pt-4 border-t border-[#DCE3EC]">
          Brug af rådene
        </h2>
        <p>
          De angivne holdbarhedstider i fryseren er vejledende og forudsætter en konstant temperatur på minimum -18 °C samt korrekt, lufttæt emballage. Ved tvivl om en madvares friskhed efter optøning anbefales det altid at bruge sine sanser (syn, lugt, smag) eller at kassere råvaren af hensyn til fødevaresikkerheden.
        </p>
      </div>

      <section className="mt-12 pt-8 border-t border-[#DCE3EC] text-sm text-[#5C6670]">
        <div className="font-semibold text-[#141B22] mb-3">Centrale kilder anvendt på sitet:</div>
        <ul className="space-y-2">
          {Object.values(SOURCES).map((src, idx) => (
            <li key={idx} className="flex items-start gap-2">
              <span className="text-[#2A4DB0] font-mono text-xs mt-1">[{idx + 1}]</span>
              <a
                href={src.url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#2A4DB0] hover:underline"
              >
                {src.title}
              </a>
            </li>
          ))}
        </ul>
      </section>
    </article>
  );
}
